<template>
  <div class="hello">
      无权限访问
  </div>
</template>

<script>
export default {
  name: 'notfound',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .hello{
        position: absolute;
        left:0;top:0;right:0;bottom:0;
        display:flex;
        justify-content: center;
        align-items: center;
        font-size:26px;
        color:#999;
    }
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue